import type { ColorSchema } from "../types";
import { ScoreboardType } from "../../Scoreboard/Common/types";

/**
 * Returns true when the scoreboard defaults to showing competitor1 (bracket-first)
 * on the RIGHT side, so callers can reverse the display order to match what the
 * operator sees on the scoreboard.
 * (Karate Kumite initialises switchedCompetitors=true so AKA/competitor1 is on the right.)
 */
export function isDefaultReversed(scoreboardType: ScoreboardType): boolean {
    return scoreboardType === "karateKumite";
}

export function getColorSchema(scoreboardType: ScoreboardType): ColorSchema {
    switch (scoreboardType) {
        case "bjjRedBlue":
        case "newaza":
        case "mmaBasic":
        case "submissionFighting2":
        case "submissionOnly":
        case "submissionOnlyWithPenalties":
        case "wrestling":
        case "grappling":
        case "combatJuJutsu":
        case "taekwondo":
            return "redblue";
        case "bjjBlueRed":
        case "fighting":
            return "bluered";
        case "judo":
            return "whiteblue";
        case "karateKumite":
            return "redwhite";
        default:
            return "default";
    }
}
